import firebase from './Firebase'

export default firebase
